/*
 * 文件EN: overdueClient.js,
 * 文件CN: 逾期客户-D10客户,D20客户,D30客户,
 * 创建人: huli
 */

import request from '@/plugins/http'

/**
 * @desc 逾期客户列表查询
 * @method GET
 * @param {}
 */
export const getListData = params => {
  return request.get('/overdue/customerList', params)
}

// /**
//  * @desc 商户还款--还款记录列表查询  第二个table
//  * @method GET
//  * @param {详细见swagger}
//  */
// export const getListDataSecond = params => {
//   return request.get('/merchantRepay/merRepayRecords', params)
// }